export default __webpack_public_path__ + "stanzazoo-d2610970e603df9118eac274c18c54c5.bundle.png";